/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CommandInputs */

const en_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command`)
};

const es_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando`)
};

const fr_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande`)
};

const de_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommando`)
};

const ja_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンド`)
};

const zh_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令`)
};

const ar_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أمر`)
};

const id_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perintah`)
};

const it_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando`)
};

const ru_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда`)
};

const pt_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando`)
};

const ko_command = /** @type {(inputs: CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명령`)
};

/**
* | output |
* | --- |
* | "Command" |
*
* @param {CommandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const command = /** @type {((inputs?: CommandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CommandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_command(inputs)
	if (locale === "es") return es_command(inputs)
	if (locale === "fr") return fr_command(inputs)
	if (locale === "de") return de_command(inputs)
	if (locale === "ja") return ja_command(inputs)
	if (locale === "zh") return zh_command(inputs)
	if (locale === "ar") return ar_command(inputs)
	if (locale === "id") return id_command(inputs)
	if (locale === "it") return it_command(inputs)
	if (locale === "ru") return ru_command(inputs)
	if (locale === "pt") return pt_command(inputs)
	return ko_command(inputs)
});